import React from 'react'
import styled from 'styled-components'
import { Spinner } from '@ripley-ui/icon'
import { ButtonProps } from '@material-ui/core/Button'
import StyledMuiButton from './StyledMuiButton'
import theme from '../theme'

export interface Props extends ButtonProps {
  /**
   * Specify if button is in a loading state
   */
  isLoading?: boolean
  /**
   * Specify if button is in a loading state
   */
  loadingIcon?: string
  /**
   * Specify if button is rounded
   */
  rounded?: boolean
}

const Button: React.FC<Props> = ({ ...props }) => {
  const {
    palette: { primary },
  } = theme

  const originalText = props.children
  const originalCallback = props.onClick

  if (props.isLoading) {
    props.onClick = (event) => {
      event.preventDefault()
    }
    props.children = (
      <StyledSpinner
        fill={
          props.variant === 'contained' ? primary.contrastText : primary.main
        }
      />
    )
  } else {
    props.onClick = originalCallback
    props.children = originalText
  }

  delete props.isLoading
  delete props.loadingIcon

  return (
    <StyledMuiButton
      data-testid="test-component"
      className="test-component-primary"
      disableElevation
      {...props}
    />
  )
}

const StyledSpinner = styled(Spinner)`
  animation: rotate-spinner 3s infinite linear;
  transform-origin: 'center center';
  padding: '1px';

  @keyframes rotate-spinner {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`

export default Button
